import { Card, CardActionArea, CardContent, CardHeader, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { LessonTeacher } from "../../Objects/OnlineLesson";
import TeacherDeldate from "../atoms/TeacherDeldate";
import TeacherRegdate from "../atoms/TeacherRegdate";

export interface LessonTeacherCardProps {
    lessonTeacher: LessonTeacher
    onClick?: (lessonTeacher: LessonTeacher) => void | undefined 
}

const LessonTeacherCard: React.FC<LessonTeacherCardProps> = ({
    lessonTeacher,
    onClick
}) => {
    let {enqueueSnackbar} = useSnackbar()

    let content = (
        <CardContent>
            <TeacherRegdate teacherData={lessonTeacher} />
            <TeacherDeldate teacherData={lessonTeacher} />
        </CardContent>
    )

    return (
        <Card variant="outlined">
            {onClick ? (
                <CardActionArea
                    onClick={()=>{
                        if( onClick ) {
                            onClick(lessonTeacher)
                        }
                    }}
                >{content}</CardActionArea>
            ) : (content)}
        </Card>
    )
}

export default LessonTeacherCard